//? -----------------------------PLUGINS------------------------- //
import { Box, BoxProps, Button, ButtonProps, Grid, GridProps, CircularProgress, useTheme } from "@mui/material";
import React from "react";
import { Trans, useTranslation } from "react-i18next";

//? -----------------------------COMPONENTS------------------------- //
import InfoMessageBox, {
    InfoMessageProps,
} from "components/messages/infoMessage";

//? ---------------------------------STYLES---------------------------- //
import CampaignIcon from "@mui/icons-material/Campaign";
import { AxiosError } from "axios";
import { NavigateFunction } from "react-router";
import { useNavigate } from "react-router-dom";
import * as ApplicationService from "services/application-service";
import * as SettingsService from "services/settings-service";
import * as Styles from "pages/requests/stepsIndividual/standalone-step0/step0.styles";
import { useSettingsContext } from "contexts/settingsContext";
import { useTenantContext } from "contexts/tenantContext";

//! --------------------------------------------------------------- //
interface ContentProps {
    showMessage: MessageBox;
}



const Content = (props: ContentProps) => {
    const { showMessage } = props;
    const { t } = useTranslation();
    const theme = useTheme();
    const navigate = useNavigate();

    const [isLoading, setIsLoading] = React.useState(false);
    const [isVertrouwelijk, setIsVertrouwelijk] = React.useState<boolean>(false);
    const { getSetting } = useSettingsContext();
    const { currentTenant } = useTenantContext();

    async function handleRequest(
        t: any,
        navigate: NavigateFunction,
        showMessage: MessageBox
    ) {
        setIsLoading(true);
        await ApplicationService.getEmptyApplicationAsync()
            .then((applicationId) => {
                setIsLoading(false);
                navigate(`${applicationId}`);
            })
            .catch((error: AxiosError<Error>) => {
                setIsLoading(false);
                if (error.code === "ERR_NETWORK") {
                    showMessage(t("errors.ERR_NETWORK"), "error", 5000);
                }
            });
    }

    const cardContentTitleProps: BoxProps = {
        component: "h1",
        sx: Styles.headerCSS(theme),
    };

    const buttonProps: ButtonProps = {
        onClick: () => handleRequest(t, navigate, showMessage),
        type: "submit",
        variant: "contained",
        sx: Styles.buttonCSS(theme),
    };

    const gridContainerProps: GridProps = {
        container: true,
    };
    const gridItemProps: GridProps = {
        item: true,
        xs: 12,
    };

    // function infoMessageBoxProps(t: any): InfoMessageProps {
    //   return {
    //     title: t("requestIndividual.step0.warningTitle"),
    //     text: t("requestIndividual.step0.warning"),
    //     icon: CampaignIcon,
    //     isCollapsable: false,
    //     isCollapsed: false,
    //   };
    // }

    const lowerCase = (input: string): string => {
        return input.charAt(0).toLowerCase() + input.slice(1);
    }

    return (
        <Grid {...gridContainerProps}>
            <Grid {...gridItemProps}>
                <Box sx={Styles.containerCSS(theme)}>
                    <Box {...cardContentTitleProps}>
                        {t("requestIndividual.step0.heading")}
                    </Box>

                    <Box sx={Styles.textCSS(theme)}>
                        <Trans i18nKey={"requestIndividual.step0.text"}  values={{
                            zoneName: currentTenant ? currentTenant.displayName : "de politie"
                        }}/>
                    </Box>
                    {getSetting<boolean>("useVertrouwelijk") &&
                        <Box sx={Styles.textCSS(theme)}>
                            <Trans i18nKey={"requestIndividual.step0.vertrouwelijk"} values={{
                                zoneName: currentTenant ? currentTenant.displayName : "de politie"
                            }} />
                        </Box>
                    }
                    <Box sx={Styles.textCSS(theme)}>
                        {t("requestIndividual.step0.warning")}
                    </Box>
                    {/* <InfoMessageBox {...infoMessageBoxProps(t)} /> */}

                    <Button {...buttonProps} disabled={isLoading}>
                        {t("requestIndividual.step0.button")}
                    </Button>
                    {isLoading && <CircularProgress />}
                </Box>
            </Grid>
        </Grid>
    );
};

export default Content;
